<!--services start-->
<section class="resume services bg-pink" id="services">
  <div class="container">
      <div class="row">
          <div class=" offset-md-2 col-md-8">

              <div class="title title2" style="margin-bottom: 0;">
                <h2 class="">Services</h2>

              </div>
              <h5 style="margin-bottom: 20px;" style="text-transform: none;">
                We offer treatment for a wide range of conditions. Our services are offered at Milnerton Medi-Clinic, Spescare Blouberg step-down facility, and the out-patient rooms in Blouberg and Tableview. Our services include the following:
              </h5>

          </div>
      </div>
      <div class="row services-main-row">
        <div class=" col-md-2 col-sm-6" *ngFor="let data of brands">
            <div class="service text-center bg-white">
                <div class="img-block">
                    <img [src]="data.img" alt="" class="service-img img-fluid">
                </div>
                <div class="service-feature">
                    <h4 class="feature-text text-center">{{data.title}}</h4>

                </div>
            </div>
        </div>
    </div>
      <div class="row" style="padding-top:20px">
          <div class="col-12 text-center" >
            <a class=" btn btn-default" (click)="openModal()">read more</a>
          </div>
      </div>

  </div>
</section>
<!--services start-->

